export enum ItemStatusEnum {
  WaitingForApproval = 'waitingForApproval',
  Approved = 'approved',
  Rejected = 'rejected',
  Deleted = 'deleted'
}
